import { JSONUtils } from '../../../utility/json-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import {
  cloneMap, isSameData, isSameMap, mapToData,
} from '../../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { BusinessModuleRef } from '../business-module-ref.js';

export class SoldTicketsPool extends DataModel {
  static readonly TYPE_ID: string = '50ee3d9c8dca44dfaf1751f3745afdab';

  constructor(
    public readonly businessRef: BusinessModuleRef,
    public readonly eventId: string,
    public readonly soldTickets: Map<string, number>,
  ) {
    super();
  }

  get $typeId(): string {
    return SoldTicketsPool.TYPE_ID;
  }

  static create(args: {
    businessRef: BusinessModuleRef,
    eventId: string,
    soldTickets: Map<string, number>,
  }): SoldTicketsPool {
    return new SoldTicketsPool(
        args.businessRef,
        args.eventId,
        args.soldTickets,
    );
  }

  static empty(args: {
    businessRef: BusinessModuleRef,
    eventId: string,
  }): SoldTicketsPool {
    return new SoldTicketsPool(
        args.businessRef,
        args.eventId,
        new Map<string, number>(),
    );
  }

  getTicketCount(templateId: string): number {
    return this.soldTickets.get(templateId) ?? 0;
  }

  static fromMap(context: SerializationContext, map: SerializedData): SoldTicketsPool {
    return this.create({
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
      eventId: MapUtils.getString(map, 'eventId'),
      soldTickets: MapUtils.getMap(map, 'soldTickets', (k, v) => ({
        key: k,
        value: JSONUtils.decodeNumber(v),
      })),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'businessRef': this.businessRef.encode(),
      'eventId': this.eventId,
      'soldTickets': mapToData(this.soldTickets, (k, v) => ({
        key: k,
        value: v,
      })),
    };
  }

  clone(): this {
    return SoldTicketsPool.create({
      businessRef: this.businessRef.clone(),
      eventId: this.eventId,
      soldTickets: cloneMap(this.soldTickets),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.businessRef, this.businessRef) &&
        other.eventId === this.eventId &&
        isSameMap(other.soldTickets, this.soldTickets);
  }
}

export class SoldTicketsPoolBuilder extends DataModelBuilder<SoldTicketsPool> {
  build(context: SerializationContext, map: SerializedData): SoldTicketsPool {
    return SoldTicketsPool.fromMap(context, map);
  }
}
